/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_404_DescriptionInputs */

const ja_error_404_description = /** @type {(inputs: Error_404_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お探しのページは一時的にアクセス出来ない状態にあるか、削除された可能性があります。`)
};

const en_error_404_description = /** @type {(inputs: Error_404_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page Not Found`)
};

/**
* | output |
* | --- |
* | "Page Not Found" |
*
* @param {Error_404_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const error_404_description = /** @type {((inputs?: Error_404_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_404_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_error_404_description(inputs)
	return en_error_404_description(inputs)
});